declare var Quill: any;

var BlockEmbed = Quill.import('blots/block/embed');
export class ConditionalPageBreak extends BlockEmbed {
}
